import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=00aa7019&"
import script from "./PartnerDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VIcon,VRow})
